import { VisionDropdownComponent } from '@core-mkt/shared/components/vision-dropdown/vision-dropdown/vision-dropdown.component';
import type { OnInit } from '@angular/core';
import { LazyImgDirective } from '@core-mkt/services/lazy-load/lazy-load.directive';
import { Component, Input } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import type { Image } from '@core-mkt/interfaces/image';
import { ImgixService } from '@core-mkt/services/imgix/imgix.service';
import type { ComponentTheme, ThemeInterface } from '@core-mkt/services/theme-parser/theme-parser.service';
import { ThemeParserService } from '@core-mkt/services/theme-parser/theme-parser.service';
import { WysiwygRedactorService } from '@core-mkt/services/wysiwg-redactor/wysiwyg-redactor.service';
import type { DropdownData } from '@core-mkt/shared/components/vision-dropdown/vision-dropdown/vision-dropdown';
import type { ReferralDropdown } from './ambassador-referral';
import { Referral } from './ambassador-referral';

declare global {
  interface Window {
    campaign: any;
  }
}

@Component({
  selector: 'ambassador-referral',
  templateUrl: './ambassador-referral.component.html',
  styleUrls: ['./ambassador-referral.component.scss'],
  standalone: true,
  imports: [VisionDropdownComponent, LazyImgDirective],
})
export class AmbassadorReferralComponent implements OnInit {
  @Input() data: Referral;
  theme: ThemeInterface;

  constructor(
    private redactor: WysiwygRedactorService,
    private themeParser: ThemeParserService,
    private imgixService: ImgixService,
  ) {}

  get image(): Image | undefined {
    return this.data.image?.[0];
  }

  get referralTitle(): SafeHtml {
    return this.data.referralTitle;
  }

  get referralContent(): SafeHtml {
    return this.data.referralContent;
  }

  get ambassadorRightContent(): SafeHtml {
    return this.data.ambassadorRightContent ? this.data.ambassadorRightContent : '';
  }

  get dropdownTitle(): string {
    return this.data.dropdownTitle;
  }

  get dropdown(): ReferralDropdown[] {
    return this.data.referralDropdown;
  }

  get dropdownData(): DropdownData {
    return {
      dropdownItems: this.dropdown,
      dropdownPlaceholder: this.dropdownTitle || 'Claim Your Course',
      dropdownAlignment: '',
    };
  }

  ngOnInit(): void {
    const themeInput: ComponentTheme = {
      styles: this.data.styles,
      backgroundColor: this.data.backgroundColor,
      backgroundImage: this.data.backgroundImage?.[0],
      textColor: this.data.textColor,
      columnDistribution: undefined,
    };
    this.theme = this.themeParser.getThemeClasses(themeInput);
    this.data.referralTitle = this.redactor.bypassSanitizer(this.data.referralTitle);
    this.data.referralContent = this.redactor.bypassSanitizer(this.data.referralContent);
    this.data.ambassadorRightContent = this.data.ambassadorRightContent
      ? this.redactor.bypassSanitizer(this.data.ambassadorRightContent)
      : undefined;
  }

  /**
   * Handles the change of the campaign value.
   *
   * @param value - The new campaign value to be set.
   */
  handleCampaignChange(value: string) {
    window.campaign = value;
  }
}
